import { createContext, useContext, useState, useMemo, useCallback, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

function detectInitialLanguage() {
  const stored = localStorage.getItem("elite_lang");
  if (stored === "nl" || stored === "en") return stored;
  const browserLang = navigator.language || navigator.userLanguage || "nl";
  return browserLang.toLowerCase().startsWith("en") ? "en" : "nl";
}

function getByPath(obj, path) {
  return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectInitialLanguage);

  useEffect(() => {
    localStorage.setItem("elite_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((newLang) => setLangState(newLang), []);
  const toggleLang = useCallback(() => setLangState((prev) => (prev === "nl" ? "en" : "nl")), []);

  const t = useMemo(() => {
    return (key, vars) => {
      const dict = translations[lang] || translations.nl;
      let value = getByPath(dict, key);
      if (value === undefined) value = getByPath(translations.nl, key);
      if (value === undefined) return key;
      if (typeof value === "string" && vars) {
        Object.keys(vars).forEach((v) => {
          value = value.replace(`{{${v}}}`, vars[v]);
        });
      }
      return value;
    };
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, toggleLang, t }), [lang, setLang, toggleLang, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
